var map = {
	"./ShiftMotion.png": 2840,
	"./ShiftMotion1.png": 7779,
	"./ShiftMotion2.png": 920,
	"./ShiftMotion3.png": 4785,
	"./ShiftMotion4.png": 8046
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4405;